import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';

@Component({
  selector: 'app-account-voucher',
  templateUrl: './account-voucher.component.html',
  styleUrls: ['./account-voucher.component.scss']
})
export class AccountVoucherComponent implements OnInit {

  @Input() isJointAccount: boolean;
  @Input() identificationType: string;
  @Input() identificationNumber: string;
  @Input() name: string;
  @Input() surname: string;
  @Input() identificationTypeJoint: string;
  @Input() identificationNumberJoint: string;
  @Input() nameJoint: string;
  @Input() surnameJoint: string;
  @Input() accountType: string;
  @Input() currencyType: number;
  @Input() openingDate: string;
  @Input() accountName: string;

  operation: any;

  constructor(
  ) {}

  ngOnInit(): void {
    this.operation = {};
  }
}
